import { useEffect, useRef, useState } from 'react'
import { Button } from '../../../../../ui'
import Tabs from '../../../../../tabs/Tabs'
import { monthsArr } from '../../../../../../utils/constant'

const MasivaContent = ({
  onFileSelect,
  archivoExcel,
  errorMessage,
  validationErrors = [],
  massiveUploadSource,
  onMassiveUploadSourceChange,
  bukMonth,
  isDownloadingTemplate = false,
  onTemplateDownload,
  onBukMonthChange
}) => {
  const fileInputRef = useRef(null)
  const [showAllValidationErrors, setShowAllValidationErrors] = useState(false)

  const visibleValidationErrors = showAllValidationErrors
    ? validationErrors
    : validationErrors.slice(0, 5)

  useEffect(() => {
    if (!archivoExcel && fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }, [archivoExcel])

  useEffect(() => {
    setShowAllValidationErrors(false)
  }, [validationErrors])

  const handleFileChange = (e) => {
    if (e.target.files?.[0]) {
      onFileSelect(e.target.files[0])
    }
  }

  const handleRemoveFile = () => {
    onFileSelect(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const renderMassivePanel = (source) => {
    const isBukUpload = source === 'buk'
    const acceptedFileTypes = isBukUpload ? '.xlsx,.xls,.csv' : '.xlsx,.xls'
    const fileTypeTitle = isBukUpload ? 'Archivo Excel o CSV' : 'Archivo Excel'
    const downloadSource = isBukUpload ? 'buk' : 'remuneration'

    return (
      <div className='grid grid-cols-1 gap-6 lg:grid-cols-[1.1fr_0.9fr]'>
        <div className='rounded-2xl border border-slate-200 bg-slate-50 p-5'>
          <p className='text-sm font-semibold font-sans text-gray-800'>
            Para ingresar datos de forma masiva, por favor sigue las siguientes instrucciones
          </p>
          <ol className='mt-3 list-decimal space-y-3 pl-5 text-sm font-sans text-gray-600'>
            {!isBukUpload ? (
              <>
                <li>
                  <div className='flex flex-col items-start gap-2'>
                    <Button
                      type='button'
                      className='rounded-full bg-accent2 text-xs uppercase text-white'
                      title={isDownloadingTemplate ? 'Descargando...' : 'Descargar plantilla Excel'}
                      disabled={isDownloadingTemplate}
                      onClick={() => onTemplateDownload?.(downloadSource)}
                    />
                  </div>
                </li>
                <li>Ingresa los datos en la plantilla descargada.</li>
                <li>Guarda el archivo en formato Excel (.xlsx o .xls).</li>
                <li>Selecciona el archivo y haz clic en Guardar.</li>
              </>
            ) : (
              <>
                <li>
                  <div className='flex flex-col items-start gap-2'>
                    <Button
                      type='button'
                      className='rounded-full bg-accent2 text-xs uppercase text-white'
                      title={isDownloadingTemplate ? 'Descargando...' : 'Descargar plantilla Excel'}
                      disabled={isDownloadingTemplate}
                      onClick={() => onTemplateDownload?.(downloadSource)}
                    />
                  </div>
                </li>
                <li>Usa como referencia el archivo BUK.xlsx para preparar la carga.</li>
                <li>Selecciona el mes asociado a la carga.</li>
                <li>Adjunta el archivo Excel o CSV correspondiente y haz clic en Guardar.</li>
              </>
            )}
          </ol>
        </div>

        <div className='rounded-2xl border border-dashed border-primary/30 bg-primary/5 p-6'>
          <div className='flex h-full flex-col items-center justify-center gap-4 text-center'>
            {isBukUpload && (
              <div className='w-full text-left'>
                <label className='block text-sm font-semibold font-sans text-gray-800'>
                  Mes de carga Buk
                </label>
                <select
                  value={bukMonth}
                  onChange={(e) => onBukMonthChange(e.target.value)}
                  className='mt-2 block w-full rounded-full border border-gray-300 px-4 py-2 text-sm font-sans text-gray-700 shadow-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary'
                >
                  <option value=''>Selecciona un mes</option>
                  {monthsArr.map((monthLabel, index) => {
                    const monthValue = String(index + 1).padStart(2, '0')
                    return (
                      <option key={monthValue} value={monthValue}>
                        {monthLabel}
                      </option>
                    )
                  })}
                </select>
              </div>
            )}

            <div className='space-y-2'>
              <p className='text-sm font-semibold font-sans text-gray-800'>{fileTypeTitle}</p>
              <p className='text-xs font-sans text-gray-500'>
                {isBukUpload
                  ? 'Selecciona el Excel o CSV exportado desde Buk para procesar la carga masiva.'
                  : 'Selecciona la plantilla completada para procesar la carga masiva de remuneraciones.'}
              </p>
            </div>

            <input
              ref={fileInputRef}
              type='file'
              accept={acceptedFileTypes}
              className='hidden'
              onChange={handleFileChange}
            />

            {archivoExcel ? (
              <div className='w-full rounded-2xl border border-blue-100 bg-blue-50 px-4 py-3 text-left'>
                <p className='text-xs font-semibold font-sans text-primary'>Archivo seleccionado</p>
                <p className='mt-1 break-all text-sm font-sans text-gray-700'>{archivoExcel.name}</p>
                <button
                  type='button'
                  onClick={handleRemoveFile}
                  className='mt-3 text-xs font-semibold font-sans text-red-500 hover:text-red-600'
                >
                  Quitar archivo
                </button>
              </div>
            ) : (
              <div className='w-full rounded-2xl bg-white/80 px-4 py-6'>
                <p className='text-sm font-sans text-gray-500'>
                  {isBukUpload
                    ? 'Aun no has seleccionado un archivo Excel o CSV para importar.'
                    : 'Aun no has seleccionado un archivo Excel para importar.'}
                </p>
              </div>
            )}

            <div className='flex w-full flex-col gap-3'>
              <Button
                type='button'
                title={archivoExcel ? 'Cambiar archivo' : 'Seleccionar archivo'}
                className='w-full rounded-full bg-primary text-sm uppercase text-white'
                onClick={() => fileInputRef.current?.click()}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='w-full rounded-3xl border border-gray-200 bg-white p-6 shadow-md'>
      <div className='flex flex-col gap-6'>
        <div>
          <h3 className='text-xl font-semibold font-sans text-gray-900'>
            Carga masiva por archivo
          </h3>
        </div>

        {errorMessage && (
          <div className='rounded-2xl border border-red-200 bg-red-100 px-4 py-3 text-xs font-semibold text-red-700 shadow-sm'>
            <div className='flex items-start gap-2'>
              <svg className='h-5 w-5 shrink-0' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                />
              </svg>
              <div className='min-w-0 whitespace-pre-wrap break-words text-left'>
                {errorMessage}
              </div>
            </div>
          </div>
        )}

        {validationErrors.length > 0 && (
          <div className='rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-xs text-red-700 shadow-sm'>
            <div className='flex items-start gap-2'>
              <svg className='mt-0.5 h-5 w-5 shrink-0' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                />
              </svg>
              <div>
                <p className='mb-1 font-semibold'>
                  {validationErrors.length} error{validationErrors.length > 1 ? 'es' : ''} de validacion detectado{validationErrors.length > 1 ? 's' : ''} en el archivo:
                </p>
                <ul className='list-disc space-y-0.5 pl-4'>
                  {visibleValidationErrors.map((err, i) => (
                    <li key={i}>{err}</li>
                  ))}
                </ul>
                {validationErrors.length > 5 && (
                  <button
                    type='button'
                    onClick={() => setShowAllValidationErrors((current) => !current)}
                    className='mt-2 text-xs font-semibold text-primary hover:underline'
                  >
                    {showAllValidationErrors ? 'Mostrar menos' : `Mostrar mas (${validationErrors.length - 5} adicionales)`}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        <div className='rounded-2xl border border-slate-200 bg-slate-50 p-4'>
          <p className='mb-2 text-sm font-semibold font-sans text-gray-800'>Tipo de carga</p>
          <Tabs
            activeIndex={massiveUploadSource === 'buk' ? 1 : 0}
            onTabClick={(index) =>
              onMassiveUploadSourceChange(index === 1 ? 'buk' : 'remuneration')
            }
            tabs={[
              {
                title: 'Remuneracion',
                content: <div className='pt-4'>{renderMassivePanel('remuneration')}</div>
              },
              {
                title: 'Buk',
                content: <div className='pt-4'>{renderMassivePanel('buk')}</div>
              }
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default MasivaContent
